module.exports = __webpack_public_path__ + "static/media/200009_epas.d242be4c.jpg";